import { DailyReportDetail, DailyReportListItem, ReportStatus } from '../Model/dailyReportXModel'
import { ReportStatus as FinanceReportStatus } from '../Model/cashReconciliationXModel'
import { stationOperationsReportService } from './stationOperationsReportService'
import { reportStationName } from './stationOperationsBXService'
import { formatReportDate } from '../Utils/stationOperations'

export const dailyReportStatusLabels: Record<FinanceReportStatus, ReportStatus> = {
  DRAFT: 'Draft',
  SUBMITTED: 'Pending Associate Review',
  ASSOCIATE_REJECTED: 'Associate Rejected',
  ASSOCIATE_APPROVED: 'Finance Review',
  FINANCE_CHANGES_REQUESTED: 'Correction Required',
  PUBLISHED: 'Published',
}

export const dailyReportBXService = {
  listAll: async (): Promise<DailyReportListItem[]> => {
    const reports = await stationOperationsReportService.listAllFinanceStatuses([
      'SUBMITTED',
      'ASSOCIATE_REJECTED',
      'ASSOCIATE_APPROVED',
      'FINANCE_CHANGES_REQUESTED',
      'PUBLISHED',
    ])

    return reports.map((report) => {
      const variance = report.varianceLitres ?? null
      return {
        id: report.resourceId,
        station: reportStationName(report),
        manager: report.submittedByName || 'Not provided',
        reportDate: report.reportDate,
        submittedAt: formatReportDate(report.submittedAt),
        status: dailyReportStatusLabels[report.status],
        variance,
        reconciliation:
          variance === null
            ? 'Not available'
            : variance > 0
              ? 'Overage'
              : variance < 0
                ? 'Shortage'
                : 'Balanced',
      }
    })
  },

  getReviewById: async (
    id: string,
    context: { station?: string; manager?: string } = {},
  ): Promise<DailyReportDetail> => {
    const detail = (await stationOperationsReportService.getById(id)).data.data
    let station = context.station
    let manager = context.manager

    if (!station || !manager) {
      const summaries = await stationOperationsReportService.listAll({
        status: detail.status,
        reportDate: detail.reportDate,
      })
      const summary = summaries.find((row) => row.resourceId === id)
      station = station || summary?.stationName || detail.stationName || detail.stationId
      manager = manager || summary?.submittedByName || 'Not provided'
    }

    return {
      id: detail.resourceId,
      station: station || detail.stationName || detail.stationId,
      manager: manager || 'Not provided',
      status: dailyReportStatusLabels[detail.status],
      submittedDateFormatted: formatReportDate(detail.submittedAt),
      managerNotes: detail.cashDifferenceExplanation,
    }
  },
}
